import React from "react";
import "./CommunityChatRoom.css";

const CommunityChatRoom = ({ messages, typing }) => {
  return (
    <section className="communityChatRoom">
      <h3 className="communityChatRoom-title">Member section</h3>
      <div className="communityChatRoom-messages">
        {messages.map((msg, index) => (
          <div key={index} className="communityChatRoom-message">
            <img
              src={require(`../../assets/images/${
                msg.user === "john" ? "john-prof-pic-07.png" : "dona-prof-pic-08.png"
              }`)}
              alt={`${msg.user}'s profile`}
              className="communityChatRoom-avatar"
            />
            <div className="communityChatRoom-content">
              <p className="communityChatRoom-user">{msg.user}</p>
              <p className="communityChatRoom-text">{msg.text}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="communityChatRoom-typing">{typing}</p>
    </section>
  );
};

export default CommunityChatRoom;
